import localeConfig from "@/config/localeConfig"
import packConfig from "@/config/packConfig"
import flightPackCode from "@/config/flightPackCode"
import responsesCache from "@/vue/planning/state/responsesCache"
import getCacheKey from "../../logic/getCacheKey"



// Types
import { AvailabilitiesResponse, AvailablePackage } from "@/types/responses"
import {type IStoreState} from "@/vue/planning/store/state/state"
import { airportCodeMap } from "@/config/airportCodeMap"

export default {
	availablePackCodes: (state: any) => {
		const defaultPackages: Array<{ codePackage: string; name: string }> = []
		// const defaultPackages = [{ codePackage: "HS", name: state.content["packages_HS"] }];

		const cacheKey = getCacheKey(
			state.packCode,
			state.dates.BeginDate,
			state.dates.EndDate,
			state.season,
			state.participants,
			state.skipass
		)
		
		const availabilityResponse = responsesCache.value.getResponse(
			"availabilities",
			cacheKey
		) as AvailabilitiesResponse

		if (!availabilityResponse) {
			return defaultPackages
		}
		const packData: any =
			availabilityResponse?.availablePackages ?? defaultPackages
		
		const availablePackCodes = packData.map((obj: any) => {
			return {
				codePackage: obj.codePackage,
				maxPromo: obj.maxPromo,
				name: state.content[`packages_${obj.codePackage}`],
				packageId: obj.prestId,
			}
		})

		state.packageId = availablePackCodes.find(
			(packObj: any) => packObj.codePackage === state.packCode
		)?.packageId

		const orderedPackages: Array<any> = []
		packConfig.forEach((packCode) => {
			const pack = availablePackCodes.find(
				(pck: any) => pck.codePackage === packCode
			)
			pack && orderedPackages.push(pack)
		})

		return orderedPackages
	},

	maxPromos: (state: any, getters: any) => {
		const responses: { [key: string]: any } = {}

		getters.availablePackCodes.forEach((packCodeObj: any) => {
			const cacheKey = getCacheKey(
				packCodeObj.codePackage,
				state.dates.BeginDate,
				state.dates.EndDate,
				state.season,
				state.participants,
				state.skipass
			)
			const availabilityResponse = responsesCache.value.getResponse(
				"availabilities",
				cacheKey
			)
			const priceResponse = responsesCache.value.getResponse("prices", cacheKey)

			responses[packCodeObj.codePackage] = priceResponse
				? priceResponse
				: availabilityResponse
		})

		const maxPromos: { [key: string]: any } = {}

		Object.entries(responses).forEach((obj: any) => {
			const [codePackage, response] = obj
			if (!response) return
			const promos = response.prestations.map((prest: any) => {
				if (!prest.maxPromo) return 0
				return parseInt(prest.maxPromo)
			})
			const maxPromo = Math.max(...promos) || promos[0]

			maxPromos[codePackage] = maxPromo
		})

		return maxPromos
	},

	maxPromosFromAvailablePackages(state: any, getters: any) {
		const responses: { [key: string]: any } = {}

		getters.availablePackCodes.forEach((packCodeObj: any) => {
			const cacheKey = getCacheKey(
				packCodeObj.codePackage,
				state.dates.BeginDate,
				state.dates.EndDate,
				state.season,
				state.participants,
				state.skipass
			)
			const availabilityResponse = responsesCache.value.getResponse(
				"availabilities",
				cacheKey
			)
			const priceResponse = responsesCache.value.getResponse("prices", cacheKey)

			responses[packCodeObj.codePackage] = priceResponse
				? priceResponse
				: availabilityResponse
		})

		const maxPromos: { [key: string]: any } = {}

		const response = responses[state.packCode]
		if (!response) return maxPromos

		response.availablePackages.forEach((availablePackage: AvailablePackage) => {
			if (!availablePackage.codePackage) return
			maxPromos[availablePackage.codePackage] = availablePackage?.maxPromo
		})
		return maxPromos
	},

	locale: (state: any) => {
		const lang: string = state.language
		return localeConfig[lang]
	},

	transport: (state: any) => {
		// FIXME remove this, this is retarded, Moris should be fired
		return state.transportCheckbox
	},
	flightOrigins: (state: IStoreState): string[] => {
		// Get the keys of the airportCodeMap (i.e., airport codes) and convert it to an array
		const orderedAirportCodes = Array.from(airportCodeMap.keys());
	
		// Sort the state.flightOrigins based on the order of airportCodes in the orderedAirportCodes list
		const sortedFlightOrigins = state.flightOrigins.sort((a, b) => {
			return orderedAirportCodes.indexOf(a) - orderedAirportCodes.indexOf(b);
		});
		return sortedFlightOrigins;
	},
	
	flightPackCodeSelected: (state: IStoreState): boolean => {
		return flightPackCode.includes(state.packCode)
	},

	flightAvailable: (_: IStoreState, getters: any): boolean => {
		return getters.availablePackCodes.some(
			(pack: { codePackage: string }) => flightPackCode.includes(pack.codePackage)
		)	
	}

}
